import { atom } from 'jotai';

export const hasTrashedAssetsAtom = atom(false);
